import KumovegaError from "./KumovegaError";

export default class ObjectAlreadyExists extends KumovegaError {}
